import PropTypes from 'prop-types'
import React, { Component, useContext, useState, createRef } from 'react'
import { BrowserRouter, Route, Link, useParams } from 'react-router-dom';
import { dbClicks, dbArticles } from '../firebase'
import { AppState } from '../context';
import emailPush from './EmailKeeper'
import {
  Ref,
  Rail,
  Sticky,
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Dimmer,
  Form
} from 'semantic-ui-react'

const Content = ({ id }) => {
  const contextRef = createRef();
  const someContext = useContext(AppState);
  const {
    articles,
    setArticles,
  } = someContext;
  console.log(articles[id])
  if (articles[id]) {
    return (
      <Ref innerRef={contextRef}>
        <Segment style={{ padding: '3em 0em' }} vertical >
          {/* <Grid.Row>
            <Grid.Column width={16} >
              <Header as='h3' style={{ fontSize: '1.63em', marginBottom: 20 }} > {articles[id]['Title']}
            </Header>
            </Grid.Column>
          </Grid.Row> */}
          <Grid.Row>
            <Grid.Column width={14}>
              <p style={{ fontSize: '1.2em', marginBottom: 20, marginTop: -40 }}>
               <i>{articles[id]['Date'] +", " +articles[id]['Author']+` co-founder of Homecare: an app to manage communication with your caregiver for stress-free senior care. Found for free`} <a href="/">here</a></i>
            </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={14}>
              {/* <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Senior Centers
              </Header> */}
              <p style={{ fontSize: '1.30em', marginBottom: 20, marginTop: 0 }}>
               {articles[id]['Intro']}
            </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={14}>
              {/* <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Special Supermarket Operating Hours for Seniors
            </Header> */}
              <p style={{ fontSize: '1.30em', marginBottom: 20 }}>
              {articles[id]['Body1']}
            </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={14}>
              {/* <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Non-Profit Delivery Services
    </Header> */}
              <p style={{ fontSize: '1.30em', marginBottom: 20 }}>
              {articles[id]['Body2']}
            </p>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={14}>
              {/* <Header as='h5' style={{ fontSize: '1.53em', marginTop: 40 }} >
                Other Services (i.e. Homecare)
    </Header> */}
              <p style={{ fontSize: '1.30em', marginBottom: "-50px" }}>
              {articles[id]['Conclusion']}

            </p>
            </Grid.Column>
          </Grid.Row>
        </Segment>
      </Ref>
    )
  }
  else {
    return null
  }

}

export default Content;